module.exports = __webpack_public_path__ + "static/media/confused.6138ec30.svg";